import React from 'react';
import cn from "classnames";

import styles from '../../lib/global.css';
import Page from '../../components/page/page';
import bindAll from "lodash.bindall";

import {getCourse, saveCourse, updateLessonSchedule} from '../../api/course';
import {setCourse} from '../../reducers/teach';

import message from '../../components/message/message';
import TitleBar from "../../components/title-bar/title-bar";
import qs from "qs";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import BannerInfo from "../../components/banner-info/banner-info";
import ButtonComponent from "../../../components/button/button";
import ModalManager from "../../components/modal/modal-manager";
import ScheduleModal from "./schedule-modal";
import LessonScheduleList from "./lesson-schedule-list";
import InviteModal from "./invite-modal";
import {showLoading} from "../../components/loading/loading";
import {getClazz, saveClazzCourse} from "../../api/clazz";
import Modal from "../../components/modal/modal";
import Message from "../../components/message/message";
import moment from 'moment';
import {
    COURSE_ACCESS_CLASS_CODE,
    COURSE_ACCESS_FREE,
    COURSE_MODE_CHALLENGE,
    COURSE_MODE_SCHEDULE
} from "../../lib/constant";


/**
 * 课程详情页
 */
class TeacherCoursePage extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'getCourse',
            'getClazz',
            'saveCourse',
            'openBatchScheduleModal',
            'openInviteModal',
            'onSetAccess',
            'onSetMode',
            'onAccessSelectChange',
            'onModeSelectChange',
            'studentsStudy'
        ]);
        this.query = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
        this.state = {course: {name: "", lessons: []}, clazz: {code: ""}};
    }

    componentDidMount() {
        this.getCourse();
        this.getClazz();
    }

    getCourse() {
        getCourse({
            clazz_id: this.query.clazz_id,
            id: this.query.id,
        }, {quiet: !!this.state.course.id}).then(res => {
            this.assessMode = res.clazz_course.access;
            this.setState({
                course: res
            },()=>{
                this.onSetMode(COURSE_MODE_SCHEDULE)
            });
        });
    }

    getClazz() {
        getClazz({id: this.query.clazz_id}, {quiet: !!this.state.clazz.id}).then(res => {
            this.setState({...this.state, clazz: res});
        });
    }

    saveCourse(course) {
        saveCourse(course).then(res => {
            message.show(window.L("teach.course.saveSuccess"));
        });
    }

    openBatchScheduleModal() {
        const {course} = this.state;
        const lessons = course.lessons;
        ModalManager.open(ScheduleModal, {
            closeAfterSubmit: true,
            onSet: (date) => {
                let schedules = [];
                for (let i = 0;i < lessons.length;++i) {
                    let lesson = lessons[i];
                    lesson.time = moment(date).format("YYYY-MM-DD HH:mm");
                    date.setDate(date.getDate() + 7);
                    schedules.push({
                        lesson_id: lesson.id,
                        time: lesson.time
                    });
                }
                updateLessonSchedule({
                    id: this.query.id,
                    clazz_id: this.query.clazz_id,
                    schedules
                }).then(() => {
                    Message.show(window.L("teach.common.saveSuccess"))
                });
                this.setState({...this.state, course: course});

            },
            onClose: () => {}
        });
    }

    openInviteModal() {
        const {course} = this.state;
        ModalManager.open(InviteModal, {
            url: window.location.href.replace('/teacher/', '/'),
            clazzCode: this.state.clazz.code,
            clazzCourseId: course.clazz_course.id,
            access: course.clazz_course.access,
            onClose: () => {},
        });
    }

    onSetAccess(access) {
        const {course} = this.state;
        course.clazz_course.access = access;
        saveClazzCourse({
            clazz_id: this.query.clazz_id,
            course_id: this.query.id,
            access: access
        }, {
            showLoading: window.L("teach.loading.setting")
        }).then(() => {
            Message.show(window.L('teach.common.setSuccess'));
        });
    }

    onSetMode(mode) {
        const {course} = this.state;
        course.clazz_course.mode = mode;
        saveClazzCourse({
            clazz_id: this.query.clazz_id,
            course_id: this.query.id,
            mode: mode
        }, {
            showLoading: window.L("teach.loading.setting")
        }).then(() => {
            this.setState({course})
            Message.show(window.L('teach.common.setSuccess'));
        });
    }

    onAccessSelectChange(access) {
        this.access = access;
    }

    onModeSelectChange(mode) {
        this.mode = mode;
    }


    studentsStudy(){
        this.props.history.push(`/course?id=${this.query.id}&clazz_id=${this.query.clazz_id}`);
    }


    render() {
        const {course, clazz} = this.state;
        return (
            <Page isModal={true} title={course.name}>
                <PageContentMargin>
                    {!!course.id &&
                        <BannerInfo
                            title={course.name}
                            cover={course.id}
                            desc={course.desc}
                            buttons={
                                <div style={{width: "100%", marginTop: "1rem"}}>
                                    <div className={styles.antCol} style={{display: "flex", marginBottom: "1rem"}}>
                                        <ButtonComponent
                                            className={cn(styles.button, clazz.id ? {} : styles.disable)}
                                            style={{
                                                height: "1.5rem"
                                            }}
                                            disabled={!clazz.id}
                                            onClick={this.studentsStudy}
                                        >
                                            {window.L("teach.lesson.experience")}
                                        </ButtonComponent>
                                    </div>
                                    {/* <div className={styles.antRow} >
                                        <div className={styles.antCol3}>
                                            <label>报名模式：</label>
                                        </div>
                                        <div className={styles.antCol3}>
                                            <select
                                                style={{marginTop: "0.2rem"}}
                                                onChange={e => {
                                                    this.onAccessSelectChange(e.target.value);
                                                    this.onSetAccess(e.target.value);
                                                }}
                                                defaultValue={course.clazz_course.access}
                                                disabled={!clazz.id || !course.id}
                                            >
                                                <option value={COURSE_ACCESS_FREE}>开放</option>
                                                <option value={COURSE_ACCESS_CLASS_CODE}>班级码验证</option>
                                            </select>
                                        </div>

                                        <div className={styles.antCol} style={{display: "flex", marginLeft: "1rem"}}>
                                            <ButtonComponent
                                                className={cn(styles.button, clazz.id ? {} : styles.disable)}
                                                style={{
                                                    height: "1.5rem"
                                                }}
                                                disabled={!clazz.id}
                                                onClick={this.openInviteModal}
                                            >
                                                {window.L("teach.course.inviteToJoin")}
                                            </ButtonComponent>
                                        </div>
                                    </div> */}

                                    <div className={styles.antRow} style={{marginTop: "1rem"}}>
                                        <div className={styles.antCol3}>
                                            <label>排课模式：</label>
                                        </div>
                                        <div className={styles.antCol3}>
                                            <select
                                                style={{marginTop: "0.2rem"}}
                                                onChange={e => {
                                                    this.onModeSelectChange(e.target.value);
                                                    this.onSetMode(e.target.value);
                                                }}
                                                defaultValue={course.clazz_course.mode}
                                                disabled={!clazz.id || !course.id}
                                            >
                                                {/* <option value={COURSE_MODE_CHALLENGE}>闯关解锁</option> */}
                                                <option value={COURSE_MODE_SCHEDULE}>定时解锁</option>
                                            </select>
                                        </div>
                                        <div className={styles.antCol} style={{display: "flex", marginLeft: "1rem"}}>
                                            <ButtonComponent
                                                className={cn(styles.button, clazz.id && course.id ? {} : styles.disable)}
                                                style={{
                                                    // display:course.clazz_course.mode == COURSE_MODE_SCHEDULE ? '':'none',
                                                    height: "1.5rem"
                                                }}
                                                onClick={this.openBatchScheduleModal}
                                                disabled={!clazz.id || !course.id}
                                            >
                                                {window.L("teach.course.batchSchedule")}
                                            </ButtonComponent>
                                        </div>
                                    </div>
                                </div>
                            }
                        />
                    }
                    {course.lessons && course.lessons.length > 0 ? (
                        <LessonScheduleList
                            clazzId={parseInt(this.query.clazz_id)}
                            courseId={course.id}
                            lessons={course.lessons}
                        />
                    ) : (
                        course.id && <div style={{padding: "2rem"}}>{window.L("teach.course.noLesson")}</div>
                    )}
                </PageContentMargin>
            </Page>
        );
    }

}



export default TeacherCoursePage;
